<template>
  <div>
    <SearchFacetOptions
      :entityType="'Contact'"
      :options="agreementTypeOptions"
      :title="'Agreement Type'"
      :fieldName="'agreementTypes'"
      :loading="agreementTypeOptionsLoading"
    />
    <SearchFacetOptions
      :entityType="'Contact'"
      :options="localityOptions"
      :title="'Locality'"
      :fieldName="'localities'"
      :loading="localityLoading"
    />
    <SearchFacetOptions
      :entityType="'Contact'"
      :options="instrumentStatusOptions"
      :title="'Instrument Status'"
      :fieldName="'instrumentStatuses'"
      :loading="instrumentStatusOptionsLoading"
    />
    <SearchFacetOptions
      :entityType="'Contact'"
      :options="instrumentRoles"
      :title="'Instrument Role'"
      :fieldName="'instrumentRoles'"
      :loading="instrumentRolesLoading"
    />
    <SearchFacetOptions
      :entityType="'Contact'"
      :options="instrumentTagOptions"
      :title="'Instrument Tags'"
      :fieldName="'instrumentTags'"
      :loading="instrumentTagsLoading"
    />
    <SearchFacetOptions
      :entityType="'Contact'"
      :options="propertyStatusOptions"
      :title="'Property Status'"
      :fieldName="'propertyStatuses'"
      :loading="propertyStatusOptionsLoading"
    />
    <SearchFacetOptions
      :entityType="'Contact'"
      :options="propertyRoles"
      :title="'Property Role'"
      :fieldName="'propertyRoles'"
      :loading="propertyRolesLoading"
    />
    <MultiTextSearchFacet
      :entityType="'Contact'"
      :title="'Service ID'"
      :fieldName="'serviceIds'"
      :placeholderText="'Enter Service ID'"
    />
    <SearchFacetOptions
      :entityType="'Contact'"
      :options="serviceRoles"
      :title="'Service Role'"
      :fieldName="'serviceRoles'"
      :loading="serviceRolesLoading"
    />
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex';
import { LookupModules } from '@/store/moduleConfig';
import MultiTextSearchFacet from '@/components/search/MultiTextSearchFacet.vue';
import SearchFacetOptions from '@/components/search/SearchFacetOptions.vue';

export default {
  name: 'InstrumentSearchFacets',
  components: {
    MultiTextSearchFacet,
    SearchFacetOptions,
  },
  computed: {
    ...mapState(LookupModules.AGREEMENT_TYPES.namespace, {
      agreementTypeOptionsLoading: state => state.loading,
    }),
    ...mapState(LookupModules.INSTRUMENT_STATUSES.namespace, {
      instrumentStatusOptionsLoading: state => state.loading,
    }),
    ...mapState(LookupModules.INSTRUMENT_ROLES.namespace, {
      instrumentRolesLoading: state => state.loading,
    }),
    ...mapState(LookupModules.LOCALITIES.namespace, {
      localityLoading: state => state.loading,
    }),
    ...mapState(LookupModules.PROPERTY_ROLES.namespace, {
      propertyRolesLoading: state => state.loading,
    }),
    ...mapState(LookupModules.PROPERTY_STATUSES.namespace, {
      propertyStatusOptionsLoading: state => state.loading,
    }),
    ...mapState(LookupModules.SERVICE_ROLES.namespace, {
      serviceRolesLoading: state => state.loading,
    }),
    ...mapState(LookupModules.INSTRUMENT_TAGS.namespace, {
      instrumentTagsLoading: state => state.loading,
    }),
    ...mapGetters(LookupModules.AGREEMENT_TYPES.namespace, {
      agreementTypeOptions: 'getActiveOptions',
    }),
    ...mapGetters(LookupModules.INSTRUMENT_STATUSES.namespace, {
      instrumentStatusOptions: 'getActiveOptions',
    }),
    ...mapGetters(LookupModules.INSTRUMENT_ROLES.namespace, {
      instrumentRoles: 'getActiveOptions',
    }),
    ...mapGetters(LookupModules.LOCALITIES.namespace, {
      localityOptions: 'getActiveOptions',
    }),
    ...mapGetters(LookupModules.PROPERTY_ROLES.namespace, {
      propertyRoles: 'getActiveOptions',
    }),
    ...mapGetters(LookupModules.PROPERTY_STATUSES.namespace, {
      propertyStatusOptions: 'getActiveOptions',
    }),
    ...mapGetters(LookupModules.INSTRUMENT_TAGS.namespace, {
      instrumentTagOptions: 'getActiveOptions',
    }),
    ...mapGetters(LookupModules.SERVICE_ROLES.namespace, {
      serviceRoles: 'getActiveOptions',
    }),
  },
  mounted() {
    // dispatch actions to populate vuex state for this page
    this.$store.dispatch(`${LookupModules.AGREEMENT_TYPES.namespace}/fetchOptions`,
      LookupModules.AGREEMENT_TYPES.url);
    this.$store.dispatch(`${LookupModules.LOCALITIES.namespace}/fetchOptions`,
      LookupModules.LOCALITIES.url);
    this.$store.dispatch(`${LookupModules.INSTRUMENT_STATUSES.namespace}/fetchOptions`,
      LookupModules.INSTRUMENT_STATUSES.url);
    this.$store.dispatch(`${LookupModules.INSTRUMENT_ROLES.namespace}/fetchOptions`,
      LookupModules.INSTRUMENT_ROLES.url);
    this.$store.dispatch(`${LookupModules.PROPERTY_STATUSES.namespace}/fetchOptions`,
      LookupModules.PROPERTY_STATUSES.url);
    this.$store.dispatch(`${LookupModules.PROPERTY_ROLES.namespace}/fetchOptions`,
      LookupModules.PROPERTY_ROLES.url);
    this.$store.dispatch(`${LookupModules.SERVICE_ROLES.namespace}/fetchOptions`,
      LookupModules.SERVICE_ROLES.url);
  },
};
</script>
